import { ChangeDetectionStrategy, Component, computed, effect, inject, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { billingScopes } from '../../../billing-consts';
import { defaultColorLabels } from '../../../configs/default-color-labels';
import { PermissionService } from '../../../services/permission.service';
import { CustomColorLabelsSettingItemComponent } from '../custom-color-labels-setting-item/custom-color-labels-setting-item.component';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';
import { GallerySettingsGroupComponent } from '../gallery-settings-group/gallery-settings-group.component';

@Component({
  selector: 'app-color-labels-setting-customize',
  imports: [
    GallerySettingsCustomizeHeaderComponent,
    GallerySettingsGroupComponent,
    FormsModule,
    ReactiveFormsModule,
    CustomColorLabelsSettingItemComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './color-labels-setting-customize.component.html',
  styleUrls: ['./color-labels-setting-customize.component.scss'],
})
export class ColorLabelsSettingCustomizeComponent {
  private permissionService = inject(PermissionService);
  gallery = input.required<GalleryDto>();
  back = output<void>();

  colors = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    if (!this.permissionService.canDisplayElement(billingScopes.asset.customLabels)) return defaultColorLabels;
    return gallery.color_labels || defaultColorLabels;
  });

  constructor() {
    effect(() => {
      const gallery = this.gallery();
      if (!gallery) return;
      if (!gallery.enabled_feedback_options.includes('color_label')) {
        this.back.emit();
      }
    });
  }
}
